import { parseDateTimeLocal } from "./dateLocal";

/** Billable hours — half-up round, minimum 1 (matches backend). */
export function parkingBillableHours(minutes) {
  return Math.max(1, Math.round(minutes / 60));
}

/** Hourly subtotal from check-in/out window. */
export function computeParkingSubtotal(pricePerHour, checkIn, checkOut) {
  const ci = parseDateTimeLocal(checkIn);
  const co = parseDateTimeLocal(checkOut);
  if (!ci || !co || co <= ci) return 0;

  const minutes = Math.floor((co - ci) / 60000);
  const hours = parkingBillableHours(minutes);
  return +(hours * Number(pricePerHour)).toFixed(2);
}

export function computeParkingSummary(spot, checkIn, checkOut) {
  const ci = parseDateTimeLocal(checkIn);
  const co = parseDateTimeLocal(checkOut);
  if (!spot || !ci || !co || co <= ci) return null;

  const minutes = Math.floor((co - ci) / 60000);
  const hours = parkingBillableHours(minutes);
  const maxHours = spot.max_hours != null ? Number(spot.max_hours) : null;
  if (maxHours && hours > maxHours) {
    return { hours, exceedsMax: true, maxHours };
  }

  const subtotal = computeParkingSubtotal(spot.price_per_hour, checkIn, checkOut);
  const fee = +(subtotal * 0.15).toFixed(2);
  return {
    hours,
    subtotal,
    fee,
    total: +(subtotal + fee).toFixed(2),
    exceedsMax: false,
  };
}
